<template>
  <tr>
    <td>
      <font-awesome-icon icon="cube" v-if="order_entry.sw_order_viison_dhl_id" />
    </td>
    <td>
      <div :title="mappingText">
        {{order_entry.source}}
      </div>
    </td>
    <td>
      {{order_entry.document_date}}
    </td>
    <td>
      {{order_entry.document_name}}
    </td>
    <td>
      <!-- <router-link :to="{name: 'OrderShow', params:{id: order_entry.order_id}}"> -->
        {{order_entry.ordernumber}}
      <!-- </router-link> -->
    </td>
    <td>
        {{order_entry.status}}
        -
        {{statusTextBeautified}}
    </td>
    <td>
        {{order_entry.cleared}}
        -
        {{clearedTextBeautified}}
    </td>
    <td>
      {{order_entry.customernumber}}
    </td>
    <td>
      {{order_entry.billing_last_name}}
      {{order_entry.billing_first_name}}
    </td>
    <td>
      {{order_entry.order_item.name}}
    </td>
    <td>
      {{order_entry.order_item.ean}}
    </td>
    <td>
      {{order_entry.order_item.sku}}
    </td>
    <td>
      {{order_entry.order_item.quantity}}
    </td>
    <td>
      <span v-if="order_entry.taxfree == 0">JA</span>
      <span v-if="order_entry.taxfree == 1">NEIN</span>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.article_price_netto}}</div>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.article_price_brutto}}</div>
    </td>
    <td>
      <div style="float:right" title="Zahlungsgebühr für Bestellung">{{order_entry.payment_fee}}</div>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.sum_price_netto}}</div>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.sum_price_brutto}}</div>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.margin_percentage}}%</div>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.rt_margin}}</div>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.ek_price_single}}</div>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.ek_price_sum}}</div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'OrderRow',
  props: ['order_entry'],
  computed: {
    statusTextBeautified(){
      if(this.order_entry.status_text == "completely_delivered"){
        return "Ausgeliefert"
      }
      return this.order_entry.status_text
    },
    clearedTextBeautified(){
      if(this.order_entry.cleared_text == "completely_paid"){
        return "Bezahlt"
      }
      return this.order_entry.cleared_text
    },
    mappingText(){
      return "Zugeordnet zu " + this.order_entry.shop_id + " - " + this.order_entry.shop_text;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrderRow.vue